import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  LinkedinLogo,
  FacebookLogo,
  InstagramLogo,
  EnvelopeSimple,
  Phone,
  MapPin
} from '@phosphor-icons/react';
import BrandLockup from './BrandLockup';

const Footer = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText('info@growmoreitservices.com');
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      /* ignore */
    }
  };

  const quickLinks = [
    { label: 'Home', href: '/' },
    { label: 'About Us', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Internship', href: '/internship' },
    { label: 'Contact Us', href: '/contact' },
    { label: 'Partner with us', href: '/#partner-register' }
  ];

  const serviceLinks = [
    { label: 'Website Development', href: '/services/website-development' },
    { label: 'WhatsApp API', href: '/services/whatsapp-business-automation' },
    { label: 'AI Automation', href: '/services/ai-automation' },
    { label: 'Digital Marketing', href: '/services/digital-marketing-seo' }
  ];

  return (
    <footer className="w-full bg-gray-50 dark:bg-[#050510] border-t border-gray-200 dark:border-white/5">
      <div className="section-max-width px-4 md:px-6 pt-12 pb-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4 max-w-xs">
            <BrandLockup size="sm" />
            <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
              Custom engineering, WhatsApp API, hosting and IT solutions from Satara.
            </p>
            <div className="flex gap-3">
              {[
                { icon: LinkedinLogo, href: 'https://www.linkedin.com/company/growmore-it-services/posts/?feedView=all', label: 'LinkedIn' },
                { icon: FacebookLogo, href: 'https://www.facebook.com/GrowmoreITServices', label: 'Facebook' },
                { icon: InstagramLogo, href: 'https://www.instagram.com/growmore_it_services?igsh=aG8yd2oyM2w0bGl4', label: 'Instagram' }
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.label}
                  className="w-9 h-9 rounded-full border border-gray-200 dark:border-white/10 flex items-center justify-center text-gray-500 hover:text-brand-600 hover:border-brand-300 transition-colors"
                >
                  <social.icon className="w-4 h-4" weight="fill" />
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="Footer Quick Links">
            <h4 className="font-display font-bold text-xs uppercase tracking-[0.16em] text-gray-400 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-700 dark:text-gray-300 hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Footer Services">
            <h4 className="font-display font-bold text-xs uppercase tracking-[0.16em] text-gray-400 mb-4">
              Services
            </h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-700 dark:text-gray-300 hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/services"
                  className="text-sm font-semibold text-brand-600 dark:text-brand-400 hover:text-brand-700"
                >
                  See all services
                </Link>
              </li>
            </ul>
          </nav>

          <div>
            <h4 className="font-display font-bold text-xs uppercase tracking-[0.16em] text-gray-400 mb-4">
              Contact
            </h4>
            <div className="space-y-3 text-sm text-gray-700 dark:text-gray-300">
              <a href="tel:+917350695792" className="flex items-start gap-2.5 hover:text-brand-600">
                <Phone className="w-4 h-4 mt-0.5 shrink-0 text-brand-600" weight="fill" />
                +91 73506 95792
              </a>
              <a href="tel:+919022487236" className="flex items-start gap-2.5 hover:text-brand-600">
                <Phone className="w-4 h-4 mt-0.5 shrink-0 text-brand-600" weight="fill" />
                +91 90224 87236
              </a>
              <button type="button" onClick={handleCopyEmail} className="flex items-start gap-2.5 text-left hover:text-brand-600">
                <EnvelopeSimple className="w-4 h-4 mt-0.5 shrink-0 text-brand-600" weight="fill" />
                {copied ? 'Email copied' : 'info@growmoreitservices.com'}
              </button>
              <p className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-brand-600" weight="fill" />
                <span>Mangalmurti Apartment, Near IT Park, Godoli, Satara</span>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-5 border-t border-gray-200 dark:border-white/5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-gray-400">
          <p>© {new Date().getFullYear()} Growmore IT Services. All rights reserved.</p>
          <p>Satara · Maharashtra · India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
